import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LogUtils } from "abweb/utils/log/LogUtils";
import { action, computed, makeObservable, observable } from "mobx";
const LOG = LogUtils.getLogger(__filename);
export let OutstandingRequestCounterImpl = (_class = class OutstandingRequestCounterImpl {
  constructor() {
    _initializerDefineProperty(this, "_outstandingRequestCount", _descriptor, this);
    makeObservable(this);
    this._outstandingRequestCount = 0;
  }
  get outstandingRequestCount() {
    return this._outstandingRequestCount;
  }
  get isBusy() {
    return this._outstandingRequestCount > 0;
  }

  /**
   * @inheritdoc
   */
  incrementOutstandingRequestCount() {
    this._outstandingRequestCount++;
  }

  /**
   * @inheritdoc
   */
  decrementOutstandingRequestCount() {
    if (this._outstandingRequestCount < 1) {
      LOG.error("*** decrementing outstanding request count below 0 from " + new Error().stack);
      return;
    }
    this._outstandingRequestCount--;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_outstandingRequestCount", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "isBusy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isBusy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "incrementOutstandingRequestCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "incrementOutstandingRequestCount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "decrementOutstandingRequestCount", [action], Object.getOwnPropertyDescriptor(_class.prototype, "decrementOutstandingRequestCount"), _class.prototype), _class);
//# sourceMappingURL=OutstandingRequestCounterImpl.js.map
